// extracted by mini-css-extract-plugin
export var photo = "GroupCard-module--photo--43f7d";
export var photoTitle = "GroupCard-module--photo-title--14865";